import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {BasketBarItem} from './BasketBarItem';
import {BasketBarStyled} from './BasketBar.style';

class BasketBar extends PureComponent {
  constructor(props) {
    super(props);
    this.editBasket = this.editBasket.bind(this);
  }

  editBasket(mealUuid, uuid) {
    const meal = this.props.editingMeals[mealUuid];
    const existingMeal = this.props.items.find(item => item.uuid === uuid);

    const basketModalItem = Object.assign({}, existingMeal, {
      sizes: meal.sizes
    });
    this.props.loadExistingBasketItem(basketModalItem);
  }

  render() {
    const {
      items,
      basketUuid,
      removeBasketItem,
      updateBasketItemQuantity,
      isExpanded,
      isTemplateLight,
      extraSpacing
    } = this.props;
    const renderBasketItems = items && items.map(item =>
      <BasketBarItem
        key={item.uuid}
        item={item}
        basketUuid={basketUuid}
        editBasket={this.editBasket}
        removeBasketItem={removeBasketItem}
        updateBasketItemQuantity={updateBasketItemQuantity}
        isTemplateLight={isTemplateLight}
      />
    );

    return (
      <BasketBarStyled
        data-rw="menu-page--basket-component"
        show={items.length > 0}
        expand={isExpanded}
        extraSpacing={extraSpacing}
      >
        {renderBasketItems}
      </BasketBarStyled>
    );
  }
}

BasketBar.propTypes = {
  items: PropTypes.array.isRequired,
  editingMeals: PropTypes.object.isRequired,
  loadExistingBasketItem: PropTypes.func.isRequired,
  removeBasketItem: PropTypes.func.isRequired,
  updateBasketItemQuantity: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  basketUuid: PropTypes.string,
  isTemplateLight: PropTypes.bool.isRequired,
  extraSpacing: PropTypes.bool
};

export default BasketBar;



// WEBPACK FOOTER //
// ./components/BasketBar/BasketBar.js